export default "__VITE_ASSET__E0sp1EQD__"